jQuery(function () {
  initClickBoxes();
});

// open-close init
function initClickBoxes() {
  jQuery('.card__clickable').on('click', function () {
    location.href = jQuery(this).find('a').attr('href');
    return false;
  });
}